<template>
  <div class="container-fluid pt-4">
    <div class="row">
      <!-- left -->
      <div class="bd-sidebar col-md-3 col-xl-2 col-12"></div>
      <!-- center -->
      <div class="bd-content col-md-9 col-xl-8 col-12 pb-md-3 pl-md-5 text-center">
        <h1>{{patient.first_name}} {{patient.last_name}} {{patient.rut}}</h1>
        <b-spinner variant="info" label="Spinning" v-if="isLoading"></b-spinner>
        <div v-else>
          <div v-if="!isNutritionist">
            <h3>Programas</h3>
            <ProgramsTable v-model="patient.programs" />
            <b-button variant="info" class="m-2" @click="showDuplicateProgramModal">Clonar programa</b-button>
            <b-button variant="info" class="m-2" @click="createProgram">Nuevo programa</b-button>
          </div>
          <div v-else>
            <h3>Pautas</h3>
            <DietsTable v-model="patient.diet_plans" />
            <b-button variant="info" class="m-2" @click="showDuplicateDietModal">Clonar pauta</b-button>
            <b-button variant="info" class="m-2" @click="createDiet">Nueva pauta</b-button>
          </div>
          <hr />
          <h3>Encuestas</h3>
          <PollsTable v-model="patient.entry_polls" />
          <b-button variant="info" class="m-2" @click="createEntryPoll">Nueva encuesta</b-button>
        </div>
      </div>
      <!-- right -->
      <div class="bd-toc col-xl-2 d-none d-xl-block">
        <div class="side-sticky">
          <ul class="section-nav nav flex-column"></ul>
        </div>
      </div>
    </div>
    <DuplicateProgramModal ref="duplicate-program-modal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import DietsTable from "../components/table/DietsTable";
import ProgramsTable from "../components/table/ProgramsTable";
import PollsTable from "../components/table/PollsTable";
import patientService from "../services/patientService";
import DuplicateProgramModal from "../components/modal/DuplicateProgramModal";
import pollsService from '../services/pollsService';
import dietService from '../services/dietService';

export default {
  name: "Patient",
  components: { 
    DietsTable,
    DuplicateProgramModal, 
    ProgramsTable, 
    PollsTable 
  },
  computed: {
    ...mapState(["login"]),
    isNutritionist: function () {
      return this.login.role === "0" || this.login.role === 0
    },
  },
  data: function() {
    return {
      patient: {},
      isLoading: true
    };
  },
  mounted: function() {
    if (this.$store.state.login.token) {
      this.getPatient();
    }
  },
  methods: {
    getPatient: function() {
      this.isLoading = true;
      patientService.get_patient({ id: this.$route.params.id }).then(
        data => {
          this.patient = data.patient;
          this.isLoading = false;
        },
        error => {
          console.error(error);
        }
      );
    },
    createProgram: function() {
      patientService.create_program({ id: this.$route.params.id }).then(
        data => {
          this.$router.push({ name: "program", params: { id: data.id } });
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    createDiet: function() {
      dietService.create_diet_plan({ id: this.$route.params.id }).then(
        data => {
          this.$router.push({ name: "diet", params: { id: data.id } });
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    createEntryPoll: function() {
      pollsService.create_entry_poll({ id: this.$route.params.id , authenticated: true }).then(
        data => {
          this.$router.push({ name: "entry_poll_admin", params: { id: data.id } });
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    showDuplicateProgramModal: function() {
      this.$refs["duplicate-program-modal"].show({
        id: "duplicate-program-modal",
        title: "Clonar un programa",
        text: "Escoge el programa que te gustaria clonar",
        programs: this.patient.programs,
        selectedId: "",
        onConfirm: id => {
          patientService.clone_program({ id: id }).then(
            data => {
              this.$router.push({ name: "program", params: { id: data.id } });
            },
            // eslint-disable-next-line
            error => {
              this.$toasted.error("Error al clonar el programa");
            }
          );
        },
        confirmText: "Clonar",
        cancelText: "Cancelar"
      });
    },
    showDuplicateDietModal: function () {
      this.$refs["duplicate-program-modal"].show({
        id: "duplicate-program-modal",
        title: "Clonar una pauta",
        text: "Escoge la pauta que te gustaria clonar",
        programs: this.patient.diet_plans,
        selectedId: "",
        onConfirm: id => {
          dietService.clone_diet({ id: id }).then(
            data => {
              this.$router.push({ name: "diet", params: { id: data.id } });
            },
            // eslint-disable-next-line
            error => {
              this.$toasted.error("Error al clonar la pauta");
            }
          );
        },
        confirmText: "Clonar",
        cancelText: "Cancelar"
      });
    }
  },
  watch: {
    // eslint-disable-next-line
    "login.token": function(newValue, oldValue) {
      if (!newValue) {
        // eslint-disable-next-line
        this.$router.push({ name: "home" }).catch(err => {});
      }
    }
  }
};
</script>

<style>
.bd-sidebar {
  border-right: 1px solid #eee;
}
.bd-toc {
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
</style>